import { NavLink } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar() {
    return (
        <aside className="sidebar">

            <div className="sidebar-logo">
                <h3>Website</h3>
                <small>Admin Panel</small>
            </div>

            <div className="menu-title">
                MAIN
            </div>

            <nav className="sidebar-menu">

                <NavLink to="/dashboard">
                    <i className="bi bi-speedometer2"></i>
                    <span>Dashboard</span>
                </NavLink>

            </nav>

            <div className="menu-title">
                CONTENT
            </div>

            <nav className="sidebar-menu">

                <NavLink to="/news">
                    <i className="bi bi-newspaper"></i>
                    <span>News</span>
                </NavLink>

                <NavLink to="/testimonials">
                    <i className="bi bi-chat-left-quote"></i>
                    <span>Testimonials</span>
                </NavLink>

                <NavLink to="/gallery">
                    <i className="bi bi-images"></i>
                    <span>Gallery</span>
                </NavLink>

                <NavLink to="/videos">
                    <i className="bi bi-play-circle"></i>
                    <span>Videos</span>
                </NavLink>

                <NavLink to="/events">
                    <i className="bi bi-calendar-event"></i>
                    <span>Events</span>
                </NavLink>

                <NavLink to="/case-studies">
                    <i className="bi bi-file-medical"></i>
                    <span>Case Studies</span>
                </NavLink>

                <NavLink to="/awards">
                    <i className="bi bi-award"></i>
                    <span>Awards</span>
                </NavLink>

                <NavLink to="/clients">
                    <i className="bi bi-people"></i>
                    <span>Clients</span>
                </NavLink>

                <NavLink to="/team-members">
                    <i className="bi bi-person-badge"></i>
                    <span>Team Members</span>
                </NavLink>

                <NavLink to="/faqs">
                    <i className="bi bi-question-circle"></i>
                    <span>FAQs</span>
                </NavLink>

            </nav>

            <div className="menu-title">
                SETTINGS
            </div>

            <nav className="sidebar-menu">

                <NavLink to="/change-password">
                    <i className="bi bi-key"></i>
                    <span>Change Password</span>
                </NavLink>

            </nav>

            <div className="sidebar-footer">
                Version 1.0
            </div>

        </aside>
    );
}